module.exports = __webpack_public_path__ + "img/sk.7d77d2db.png";